export default "__VITE_ASSET__bNMvMQRW__"